import React from "react";
import InnerHeader from "./InnerHeader";
import ContactSec from "./ContactSec";
import FaqPart from "./FaqPart";
import CtaSec from "./CtaSec";
import ContactPageForm from "./ContactPageForm";

const Contact = () => {
  return (
    <div className="contact-page">
      <InnerHeader heading="Contact Us" />
      <section className="con-sec">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-12">
              {/* <FaqPart /> */}
              <div className="con-map">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d462561.6574537445!2d55.22748795!3d25.076022449999996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f43496ad9c645%3A0xbde66e5084295162!2sDubai%20-%20United%20Arab%20Emirates!5e0!3m2!1sen!2sin!4v1757601534075!5m2!1sen!2sin"
                  width="100%"
                  height="100%"
                  // style="border:0;"
                  allowfullscreen=""
                  loading="lazy"
                  referrerpolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>
            </div>
            <div className="col-lg-6 col-12">
              <ContactPageForm />
            </div>
          </div>
        </div>
      </section>
      <CtaSec />
    </div>
  );
};

export default Contact;
